"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Merrco_1 = require("../Payments/Merrco");
var API_1 = require("../../API");
var CreateMerrcoDataCandyTransaction = /** @class */ (function (_super) {
    __extends(CreateMerrcoDataCandyTransaction, _super);
    function CreateMerrcoDataCandyTransaction(transaction, device) {
        var _this = _super.call(this, { amount: transaction.amount }, device) || this;
        _this.OriginalInvoiceNumber = '000000000000';
        _this.ReferenceNumber = '';
        var refundTerminalInvoiceId = transaction.refundTerminalInvoiceId, referenceNumber = transaction.referenceNumber;
        if (refundTerminalInvoiceId) {
            /**
             * Required for data candy cancellation
             * OriginalInvoiceNumber refers to 8004761 with leading 0's to make it a 12-digit number
             */
            _this.OriginalInvoiceNumber = refundTerminalInvoiceId;
        }
        if (referenceNumber) {
            /**
             * Required for data candy cancellation
             */
            _this.ReferenceNumber = referenceNumber;
        }
        return _this;
    }
    Object.defineProperty(CreateMerrcoDataCandyTransaction.prototype, "dataCandyRequestPayload", {
        get: function () {
            return Merrco_1.jsonToQueryString(this.commonRequestPayloadObject);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateMerrcoDataCandyTransaction.prototype, "dataCandyBalanceRequestPayload", {
        get: function () {
            delete this.commonRequestPayloadObject.Amount;
            return Merrco_1.jsonToQueryString(this.commonRequestPayloadObject);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateMerrcoDataCandyTransaction.prototype, "dataCandyCancelRequestPayload", {
        get: function () {
            var payload = __assign({}, this.commonRequestPayloadObject, { OriginalTerminalInvoiceNumber: this.convertItemToLength(this.OriginalInvoiceNumber, 12), ReferenceNumber: this.ReferenceNumber });
            return Merrco_1.jsonToQueryString(payload);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateMerrcoDataCandyTransaction.prototype, "encryptedDataCandyActivateRequestPayload", {
        get: function () {
            return Merrco_1.base64Encryption(this.dataCandyRequestPayload);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateMerrcoDataCandyTransaction.prototype, "encryptedDataCandyIncrementRequestPayload", {
        get: function () {
            return Merrco_1.base64Encryption(this.dataCandyRequestPayload);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateMerrcoDataCandyTransaction.prototype, "encryptedDataCandyBalanceRequestPayload", {
        get: function () {
            return Merrco_1.base64Encryption(this.dataCandyBalanceRequestPayload);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateMerrcoDataCandyTransaction.prototype, "encryptedDataCandyPurchaseRequestPayload", {
        get: function () {
            return Merrco_1.base64Encryption(this.dataCandyRequestPayload);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateMerrcoDataCandyTransaction.prototype, "encryptedDataCandyCancelRequestPayload", {
        get: function () {
            return Merrco_1.base64Encryption(this.dataCandyCancelRequestPayload);
        },
        enumerable: true,
        configurable: true
    });
    return CreateMerrcoDataCandyTransaction;
}(Merrco_1.CreateMerrcoTransaction));
exports.CreateMerrcoDataCandyTransaction = CreateMerrcoDataCandyTransaction;
var MerrcoDataCandyStore = /** @class */ (function () {
    function MerrcoDataCandyStore(payload, device) {
        var _this = this;
        this.getBalance = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, API_1.API.merrcoDataCandyBalance(this.transaction.encryptedDataCandyBalanceRequestPayload, this.merrcoApiAuthKey)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.trimReturnCode(response)];
                }
            });
        }); };
        this.activate = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, API_1.API.merrcoDataCandyActivate(this.transaction.encryptedDataCandyActivateRequestPayload, this.merrcoApiAuthKey)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.trimReturnCode(response)];
                }
            });
        }); };
        this.increment = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, API_1.API.merrcoDataCandyIncrement(this.transaction.encryptedDataCandyIncrementRequestPayload, this.merrcoApiAuthKey)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.trimReturnCode(response)];
                }
            });
        }); };
        this.purchase = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, API_1.API.merrcoDataCandyPurchase(this.transaction.encryptedDataCandyPurchaseRequestPayload, this.merrcoApiAuthKey)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.trimReturnCode(response)];
                }
            });
        }); };
        this.cancel = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, API_1.API.merrcoDataCandyCancel(this.transaction.encryptedDataCandyCancelRequestPayload, this.merrcoApiAuthKey)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.trimReturnCode(response)];
                }
            });
        }); };
        this.trimReturnCode = function (response) { return (__assign({}, response, { returnCode: response.returnCode.trim() })); };
        if (!device) {
            throw new Error('Device not found');
        }
        if (!device.merrcoApiAuthKey) {
            throw new Error('Merrco API auth key is required');
        }
        this.merrcoApiAuthKey = device.merrcoApiAuthKey;
        this.transaction = new CreateMerrcoDataCandyTransaction(payload, device);
    }
    MerrcoDataCandyStore.minCentValue = 500;
    MerrcoDataCandyStore.maxCentValue = 25000;
    MerrcoDataCandyStore.isCreditValid = function (credit) {
        return MerrcoDataCandyStore.minCentValue <= credit && credit <= MerrcoDataCandyStore.maxCentValue;
    };
    return MerrcoDataCandyStore;
}());
exports.MerrcoDataCandyStore = MerrcoDataCandyStore;
//# sourceMappingURL=MerrcoDataCandy.js.map